<app-internaluser [state]="viewState.Edit"></app-internaluser>
